__turbopack_context__.v({
  "helpBtn": "StudentAffairsCTA-module__GGa-uq__helpBtn",
  "helpOverlay": "StudentAffairsCTA-module__GGa-uq__helpOverlay",
  "helpSection": "StudentAffairsCTA-module__GGa-uq__helpSection",
  "helpTitle": "StudentAffairsCTA-module__GGa-uq__helpTitle",
});
